module.exports = __webpack_public_path__ + "img/carrusel_1.39341f07.jpg";